import React, { Component } from "react";

import styled from "styled-components";
import BaseLayout from "../../Layouts/BaseLayout";
import PageBanner from "../../Layouts/PageBanner";
import { LeftSection } from "./LeftSection";
import { RightSection } from "./RightSection";

class Intro1 extends Component {
  render() {
    const title =
      this.props.lang === "en"
        ? "Introduce - Poinsettia Festival English"
        : "Thể lệ cuộc thi - Giải thưởng cống hiến 2023";

    return (
      <Styles>
        <BaseLayout title={title}>
          <PageBanner />
          <div className="bs-container">
            <div className="content">
              <LeftSection />
              <RightSection />
            </div>
          </div>
        </BaseLayout>

        {/* <ContentLayout
          title={title}
          pageTitle={<FormattedMessage id="nav.intro" />}
          // content={intro}
          setLang={this.props.setLang}
        ></ContentLayout> */}
      </Styles>
    );
  }
}

export default Intro1;

const Styles = styled.div`
  .content {
    margin: 0 0 42px;
    display: flex;
  }
`;

const Styles2 = styled.div`
  .section-rules {
    background: #111423;

    .module-rules {
      .module-content {
        background: #111423;
        border-radius: 8px;
        box-shadow: none;
        border-top: 0;
        padding: 0;
        .body {
          color: white !important;
          padding-top: 31px;
          padding-left: 0;
          padding-right: 0;
          .purpose-wrapper {
            /* background: #faf1e3; */
            border-radius: 50px;
            padding: 11px 12px;
            margin-bottom: 50px;
            .purpose {
              border: 3px dashed #be904b;
              border-radius: 50px;
              padding: 30px 58px;
              h2 {
                margin-top: 0%;
                margin-bottom: 12px;
                span {
                  font-size: 28px;
                }
              }
              p {
                span {
                  font-size: 16px;
                }
              }
            }
          }
          .vote-rules {
            h2 {
              font-size: 24px;
              margin-bottom: 40px;
            }
            .step {
              margin-bottom: 40px;
              h3 {
                padding-left: 63px;
                font-size: 18px;
                position: relative;
                margin-bottom: 20px;
                &::before {
                  position: absolute;
                  content: url("../images/icon-1.svg");
                  display: block;
                  top: 50%;
                  left: 0;
                  transform: translateY(-50%);
                }
              }
              p {
                position: relative;
                padding-left: 63px;
                font-size: 16px;
                margin-bottom: 0;
                padding-bottom: 12px;
                &::before {
                  position: absolute;
                  content: "";
                  display: block;
                  width: 1px;
                  height: 100%;
                  /* background: #61ce58; */
                  top: 50%;
                  left: 20.5px;
                  transform: translateY(-50%);
                }
              }

              ul {
                li {
                  padding-left: 63px;
                  position: relative;
                  strong {
                    font-size: 18px;
                  }
                  &::before {
                    position: absolute;
                    content: "";
                    display: block;
                    width: 15px;
                    height: 15px;
                    /* background: #fff; */
                    border-radius: 50%;
                    border: 3px solid #84da7d;
                    top: 50%;
                    left: 14px;
                    transform: translateY(-50%);
                  }
                }
              }
            }
            .prize {
              h3 {
                padding-left: 63px;
                font-size: 18px;
                position: relative;
                margin-bottom: 20px;
                &::before {
                  position: absolute;
                  content: url("../images/icon-2.svg");
                  display: block;
                  top: 50%;
                  left: 0;
                  transform: translateY(-50%);
                }
              }
              ul {
                padding-left: 63px;
              }
            }
          }
        }
      }
    }
    table,
    th,
    td {
      text-align: center;
      border: 1px solid white;
    }
    .title {
      display: none;
    }
  }
  @media screen and (max-width: 768px) {
    .section-rules {
      .module-rules {
        .module-content {
          .body {
            .purpose-wrapper {
              margin-bottom: 50px;
              .purpose {
                h2 {
                  text-align: center !important;
                  span {
                    font-size: 24px;
                  }
                }
                padding: 20px 30px;
              }
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 425px) {
    .section-rules {
      .module-rules {
        .module-content {
          .body {
            .purpose-wrapper {
              margin-bottom: 50px;
              padding: 10px 10px;
              .purpose {
                h2 {
                  text-align: center !important;
                  span {
                    font-size: 20px;
                  }
                }
                padding: 20px 20px;
              }
            }
            .vote-rules {
              .step {
                p {
                  padding-left: 0;
                  &::before {
                    display: none;
                  }
                }
                ul {
                  li {
                    padding-left: 0;
                    &::before {
                      display: none;
                    }
                  }
                }
              }
              .prize {
                ul {
                  padding-left: 0;
                }
              }
            }
          }
        }
      }
    }
  }
`;
